import { CL_PRODUCT_COPY } from "@/domains/manual-cl-page/cl-product-copy"

import { NavigationSubItem } from "../navigation-item"

export class ManualClV2LiquiditySubItem extends NavigationSubItem {
  readonly id = "manual-cl-v2"
  readonly label = CL_PRODUCT_COPY.v2.shortName
  readonly href = "/liquidity/cl/v2"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}

export class ManualClV2AllPoolsSubItem extends NavigationSubItem {
  readonly id = "manual-cl-v2-all-pools"
  readonly label = CL_PRODUCT_COPY.v2.shortName
  readonly href = "/liquidity/cl/v2?view=all-pools"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}

export class ManualClV2MyPositionsSubItem extends NavigationSubItem {
  readonly id = "manual-cl-v2-my-positions"
  readonly label = "My Positions"
  readonly href = "/liquidity/cl/v2?view=my-positions"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}
